import { Routes } from '@angular/router';
import { signedOutOnlyMatchGuard } from './auth.guards';
import { APP_ROUTE_PATHS } from '../core/routing/app-route-paths';

export const AUTH_ROUTES: Routes = [
  {
    path: APP_ROUTE_PATHS.signIn,
    canMatch: [signedOutOnlyMatchGuard],
    loadComponent: () =>
      import('./sign-in-page.component').then((m) => m.SignInPageComponent)
  }
];
